import clsx from "clsx";
import useDeviceType from "hooks/useDeviceType";
import { IFactoringCompany } from "models/HaulPay";

type FactoringCompanyProps = {
  factoring_company: IFactoringCompany;
  onClickCompany: VoidFunction;
};

export default function FactoringCompany({
  factoring_company,
  onClickCompany
}: Readonly<FactoringCompanyProps>) {
  const { isDesktop } = useDeviceType();
  const fullAddress = [
    factoring_company.street_one,
    factoring_company.city,
    factoring_company.state
  ].join(", ");

  return (
    <button
      className="px-2 py-1 mx-2 my-1 hover:bg-background rounded-md flex flex-col gap-1"
      onClick={onClickCompany}>
      <span>
        {factoring_company.name}
        {isDesktop ? `: ${fullAddress}` : ""}
      </span>
      {!isDesktop ? <span>{fullAddress}</span> : null}
      <span>{factoring_company.email}</span>
      <span
        className={clsx(
          "uppercase",
          factoring_company.status === "approved" ? "text-success" : "text-primary"
        )}>
        {factoring_company.status}
      </span>
    </button>
  );
}
